import React, { useState } from 'react';
import { ChevronDown, Check, Circle } from 'lucide-react';
import { EVENTS } from '../../data/onboardingFunnel';

/** The events behind each number on the page, and which exist today. Collapsed. */
export function EventSpecTable() {
  const [open, setOpen] = useState(false);
  const live = EVENTS.filter(e => e.tracked).length;
  return <section className="overflow-hidden rounded-xl border border-neutral-200 bg-white" data-id="element-557" data-mp="2ujzfajguna7o">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="flex w-full items-center gap-3 px-5 py-4 text-left" data-id="element-558" data-mp="3r7vsrfgzppeo">
        <span className="min-w-0 flex-1" data-id="element-559" data-mp="3iftzq2993bef">
          <span className="block text-[15px] font-bold" data-id="element-560" data-mp="3ieiurz42jxlq">
            Events behind these numbers
          </span>
          <span className="block text-[13px] text-neutral-500" data-id="element-561" data-mp="3dgquagpcz35x">
            {EVENTS.length} events · {live} live · {EVENTS.length - live} not
            tracked yet
          </span>
        </span>
        <ChevronDown size={18} className={`shrink-0 text-neutral-400 transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-562" data-mp="9yz7dgq2x9el" />
      </button>

      {open && <ul className="divide-y divide-neutral-100 border-t border-neutral-100" data-id="element-563" data-mp="skvxesgwf018">
          {EVENTS.map(e => <li key={e.event} className="flex flex-wrap items-baseline gap-x-2.5 gap-y-1 px-5 py-3" data-id="element-564" data-mp="ethesmqwl0up">
              <code className={`rounded px-1.5 py-0.5 font-mono text-[12px] ${e.tracked ? 'bg-neutral-100 text-neutral-600' : 'bg-[#FFEDD5] text-[#C2410C]'}`} data-id="element-565" data-mp="iu197ik3dqd5">
                {e.event}
              </code>
              <span className={`inline-flex items-center gap-1 text-[11.5px] font-bold ${e.tracked ? 'text-emerald-700' : 'text-[#C2410C]'}`} data-id="element-566" data-mp="9u4ry2017ts4">
                {e.tracked ? <Check size={11} data-id="element-567" data-mp="3s1u8hxg0f5g1" /> : <Circle size={9} data-id="element-568" data-mp="3w0t955upkg1o" />}
                {e.tracked ? 'Live' : 'Not tracked'}
              </span>
              <span className="w-full text-[12.5px] text-neutral-500 sm:ml-auto sm:w-auto sm:text-right" data-id="element-569" data-mp="1q7l7lplr8iy6">
                {e.fires}
              </span>
              <span className="w-full font-mono text-[11.5px] text-neutral-400" data-id="element-570" data-mp="1u8wxlw8jj66w">
                {e.properties.join(' · ')}
              </span>
            </li>)}
          <li className="bg-neutral-50 px-5 py-3.5 text-[12.5px] leading-relaxed text-neutral-500" data-id="element-571" data-mp="2y7ad7928te5h">
            Every event carries <code className="font-mono" data-id="element-572" data-mp="2u6i6amguflcd">workspace_id</code>,
            with the anonymous id from first page load aliased at sign-in so a
            click and a subscription resolve to one journey.
          </li>
        </ul>}
    </section>;
}